<template>
	<div>
		<!-- 顶部 -->
		<div class="header-body">
			<Button type="primary" @click="add">添加</Button>
			<Form :label-width="80" inline>
				<FormItem label="姓名" class="search-item">
					<Input @keydown.enter.native.prevent="getList(1)" v-model="search.name" placeholder="请输入诗人姓名" style="width: 200px;"></Input>
				</FormItem>
				<Button type="info" @click="getList(1)">搜索</Button>
				<Button type="default" @click="clearSearch" icon="md-refresh"></Button>
			</Form>
		</div>
		<Divider />
		<!-- table -->
		<Table :columns="columns" :data="data" border></Table>
		<!-- 分页 -->
		<div class="page-body">
			<Page :total="total" :current='page' @on-change="changePage" show-elevator show-total/>
		</div>
		
		<!-- 头像 -->
		<Modal v-model="addShow" :title="addTitle" width="1300" :mask-closable="false">
			<Form ref="formData" :model="formData" :rules="ruleFormData" :label-width="80">
				<Row>
					<Col span="12">
						<FormItem label="姓名" prop="name">
							<Input v-model="formData.name" placeholder="请输入诗人姓名" style="width: 200px;"></Input>
						</FormItem>
						<FormItem label="朝代" prop="dynasty">
							<Input v-model="formData.dynasty" placeholder="请输入朝代" style="width: 200px;"></Input>
						</FormItem>
						<FormItem label="生平">
							<Input type="textarea" v-model="formData.content" placeholder="请输入生卒" style="width: 500px;" :rows="25"/>
						</FormItem>
					</Col>
					<Col span="12">
						<FormItem label="头像">
							<Uploads v-if="addShow" :images="formData.head_img" @send-img="getImg"></Uploads>
						</FormItem>
						<FormItem label="简述">
							<Input type="textarea" v-model="formData.desc" placeholder="请输入简述" style="width: 500px;" :rows="3"/>
						</FormItem>
						<FormItem label="延伸信息">
							<Input type="textarea" v-model="formData.extra" style="width: 500px;" :rows="25"/>
						</FormItem>
					</Col>
				</Row>
			</Form>
			<div slot="footer">
				<Button type="default" @click="addShow = false;">取消</Button>
				<Button type="primary" @click="submit">提交</Button>
			</div>
		</Modal>
	</div>
</template>

<script>
	import Uploads from '@/components/Uploads'
	import { getAuthor, addAuthor,editAuthor,deleteAuthor,getAuthorDetail,changeAuthorCustom } from '@/utils/wenxue.js'
	export default {
		name: 'Author',
		components: {
			Uploads
		},
		data() {
			return {
				search:{
					name:''
				},
				page:1,
				total:0,
				data: [],
				columns: [
					{
						title:'序号',
						width:80,
						align:'center',
						render:(h,param)=>{
							return h('span',{},param.index - 0 + 1)
						}
					},
					{
						title:'姓名',
						width:120,
						align:'center',
						key:'name'
					},
					{
						title:'朝代',
						width:120,
						align:'center',
						key:'dynasty'
					},
					{
						title: '头像',
						minWidth: 150,
						align: 'center',
						render:(h,param)=>{
							if(!param.row.head_img) return false;
							return h('img',{
								attrs:{
									src:param.row.head_img
								},
								style:{
									width:'58px',
									height:'58px'
								}
							})
						}
					},
					{
						title: '推荐',
						width: 150,
						align: 'center',
						render:(h,param)=>{
							var _that = this;
							return h('i-switch',{
								props:{
									value:param.row.is_custom == 1 ? false : true,
									size:'large'
								},
								on:{
									'on-change':()=>{
										changeAuthorCustom({id:param.row.id}).then((res)=>{
											_that.$Message.info('操作成功');
											_that.getList(_that.page);
										})
									}
								}
							},[
								h('span',{slot:'open'},'是'),
								h('span',{slot:'close'},'否')
							])
						}
					},
					{
						title: '操作',
						minWidth: 150,
						align: 'center',
						render: (h, param) => {
							var _that = this;
							return h('div', [
								h('Button', {
									props: {
										type: 'primary',
										size: 'small'
									},
									style: {
										marginRight: '6px'
									},
									on: {
										'click': function() {
											_that.formData.id = param.row.id;
											_that.getAuthorDetail();
										}
									}
								}, '编辑'),
								h('Button', {
									props: {
										type: 'error',
										size: 'small'
									},
									style: {

									},
									on: {
										'click': function() {
											_that.$Modal.confirm({
												title: '删除确认',
												content: '该操作不可逆，是否确认删除？',
												onOk: function() {
													deleteAuthor({
														id: param.row.id
													}).then(res => {
														_that.$Message.info('操作成功');
														let index = null;
														_that.data.forEach((e, key) => {
															if(e.id == res) {
																index = key;
															}
														})

														if(index !== null) _that.data.splice(index, 1);
													})
												}
											})
										}
									}
								}, '删除')
							])
						}
					}
				],
				addShow: false,
				addTitle:'添加诗人',
				formData: {
					id:0,
					name:'',
					dynasty:'',
					head_img:[],
					desc:'',
					content:'',
					extra:''
				},
				ruleFormData:{
					name:[{
						required: true,
						message: '请输入诗人姓名',
						trigger: 'blur'
					}],
					dynasty:[{
						required: true,
						message: '请输入朝代名称',
						trigger: 'blur'
					}],
				}
			}
		},
		methods: {
			changePage(page){
				this.getList(page);
			},
			async getList(page) {
				this.page = page;
				const param = {
					page:page || 1,
					page_num:10,
					name:this.search.name
				};
				
				const data = await getAuthor({form:param});

				this.data = data['data'];
				this.total = data['total'];
			},
			add() {
				this.addShow = true;
				this.addTitle = '添加诗人';
				
				this.formData.id = 0;
				this.formData.name = '';
				this.formData.dynasty = '';
				this.formData.head_img = [];
				this.formData.desc = '';
				this.formData.content = '';
				this.formData.extra = '';
			},
			getImg(img) {
				this.formData.head_img = img;
			},
			getHtml1(html){
				this.formData.content = html;
			},
			getHtml2(html){
				this.formData.extra = html;
			},
			submit() {
//				if(this.formData.head_img.length == 0){
//					this.$Message.warning('请上传图片');
//					
//					return false;
//				}
				
				var _that = this;
				this.$refs['formData'].validate((valid) => {
					if(valid) {
						const param = { ..._that.formData};
						
						if(param.id > 0) {
							editAuthor({
								form: param
							}).then((res) => {
								_that.$Message.info('编辑成功');
								_that.addShow = false;
								_that.getList(_that.page);
							})
						} else {
							addAuthor({
								form: param
							}).then((res) => {
								_that.$Message.info('添加成功');
								_that.addShow = false;
								_that.getList();
							})
						}
					}
				})
			},
			getAuthorDetail(){
				getAuthorDetail({id:this.formData.id || 0}).then((res)=>{
					this.addShow = true;
					this.addTitle = '编辑诗人';
					this.formData = {...res};
				})
			},
			clearSearch(){
				this.search.name = '';
				this.getList();
			}
		},
		mounted() {
			this.getList();
		}
	}
</script>

<style scoped>
	.ivu-layout {
		height: 100vh !important;
	}
	
	.header-body {
		width: 100%;
		min-height: 36px;
		display: flex;
		align-items: center;
		justify-content: space-between;
	}
	
	.ivu-divider-horizontal {
		margin: 12px !important;
	}
	.page-body{
		width: 100%;
		height: 50px;
		display: flex;
		align-items: center;
		justify-content: flex-end;
		margin-top: 12px;
	}
	.search-item{
		margin-bottom: 0px !important;
	}
</style>


// WEBPACK FOOTER //
// src/views/wenxue/Author.vue